import { Injectable } from "@angular/core";
import {
  AngularFirestore,
  AngularFirestoreCollection,
} from "angularfire2/firestore";
import { Observable } from "rxjs";
import * as firebase from "firebase/app";
import * as moment from "moment";

import {
  ITrainingCard,
  ITrainingCardStaff,
} from "./../../interfaces/training-cards";

@Injectable()
export class TrainingCardsProvider {
  // private trainingCardCollection: AngularFirestoreCollection<ITrainingCard>;

  constructor(private db: AngularFirestore) {}

  getTrainingCards(province: string): Observable<ITrainingCard[]> {
    let now = moment().format();
    return this.db
      .collection<ITrainingCard>("trainingCards", (ref) =>
        ref
          .where("status", "==", 0)
          .where("end", ">=", now)
          .where("province", "==", province)
          .orderBy("end", "asc")
      )
      .valueChanges();
  }

  getTrainingCardDetails(id: string): Observable<ITrainingCard> {
    return this.db
      .collection("trainingCards")
      .doc<ITrainingCard>(id)
      .valueChanges();
  }

  createTrainingCardStaff(trainingCardStaff: ITrainingCardStaff) {
    const id = this.db.createId();
    trainingCardStaff.id = id;
    trainingCardStaff.status = 0;
    const trainingCardStaffRef = this.db
      .collection(`trainingCardStaff`)
      .doc(`${trainingCardStaff.trainingCardId}`)
      .collection("staff")
      .doc(`${trainingCardStaff.userId}`);
    const userTrainingCardsRef = this.db
      .collection(`userTrainingCards`)
      .doc(`${trainingCardStaff.userId}`)
      .collection("trainingCards")
      .doc(`${trainingCardStaff.trainingCardId}`);
    trainingCardStaffRef.set(trainingCardStaff);
    userTrainingCardsRef.set(trainingCardStaff);
    userTrainingCardsRef.update({
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
    });
    return trainingCardStaffRef.update({
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
    });
  }

  cancelTrainingCardApplication(trainingCardId: string, userId: string) {
    const trainingCardStaffRef = this.db
      .collection(`trainingCardStaff`)
      .doc(`${trainingCardId}`)
      .collection("staff")
      .doc(`${userId}`);
    const userTrainingCardsRef = this.db
      .collection(`userTrainingCards`)
      .doc(`${userId}`)
      .collection("trainingCards")
      .doc(`${trainingCardId}`);
    trainingCardStaffRef.delete();
    return userTrainingCardsRef.delete();
  }

  getUserTrainingCards(userId: string): Observable<ITrainingCardStaff[]> {
    return this.db
      .collection("userTrainingCards")
      .doc(`${userId}`)
      .collection<ITrainingCardStaff>("trainingCards")
      .valueChanges();
  }

  getTrainingCardStaff(
    trainingCardId: string
  ): Observable<ITrainingCardStaff[]> {
    return this.db
      .collection("trainingCardStaff")
      .doc(`${trainingCardId}`)
      .collection<ITrainingCardStaff>("staff")
      .valueChanges();
  }
}



// WEBPACK FOOTER //
// ./src/providers/training/training.ts